// ─── Python backend (data / analysis) ────────────────────
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
  survivalAnalysis: `${API_BASE_URL}/survival-analysis`,
  filtersData:      `${API_BASE_URL}/filters-data`,
  health:           `${API_BASE_URL}/health`,
  safetyProfile:    `${API_BASE_URL}/safety-profile`,
};

// ─── Node RBAC backend (auth / user management) ───────────
export const RBAC_BASE_URL = process.env.REACT_APP_RBAC_URL || 'http://localhost:4000';

export const RBAC_ENDPOINTS = {
  login:          `${RBAC_BASE_URL}/api/auth/login`,
  logout:         `${RBAC_BASE_URL}/api/auth/logout`,
  refreshToken:   `${RBAC_BASE_URL}/api/auth/refresh-token`,
  me:             `${RBAC_BASE_URL}/api/auth/me`,
  acceptTerms:    `${RBAC_BASE_URL}/api/auth/accept-terms`,
  forgotPassword: `${RBAC_BASE_URL}/api/auth/forgot-password`,
  resetPassword:  `${RBAC_BASE_URL}/api/auth/reset-password`,
  users:          `${RBAC_BASE_URL}/api/users`,
  roles:          `${RBAC_BASE_URL}/api/roles`,
  filtersConfig:   `${RBAC_BASE_URL}/api/filters/config`,
  auditLogs:       `${RBAC_BASE_URL}/api/audit-logs`,
  changePassword:  `${RBAC_BASE_URL}/api/auth/change-password`,
  syncPreview:     `${RBAC_BASE_URL}/api/sync/preview`,
  syncImport:      `${RBAC_BASE_URL}/api/sync/import`,
  userAssignments: (id) => `${RBAC_BASE_URL}/api/users/${id}/assignments`,
  userHospitals:   (id) => `${RBAC_BASE_URL}/api/users/${id}/hospitals`,
  metaHospitals:   `${RBAC_BASE_URL}/api/users/meta/hospitals`,
  metaZones:       `${RBAC_BASE_URL}/api/users/meta/zones`,
  metaSalesReps:   `${RBAC_BASE_URL}/api/users/meta/sales-reps`,
  metaZBMs:        `${RBAC_BASE_URL}/api/users/meta/zbms`,
  // metaZBMs:        `${RBAC_BASE_URL}/api/users/meta/zbms`,
  patientDeepDive: `${RBAC_BASE_URL}/api/patients/deep-dive`,
};

export default API_BASE_URL;
